
 
<div>
  <section class="form-tasklist">
    <mat-card>
      <mat-card-title>
        Accept Terms
      </mat-card-title>

      <div style="margin-top:21px;">
        <form [formGroup]="formPermissions" autocomplete="nope">
          <mat-checkbox
            style="margin-left: 3px;"
            id="confirmReviewedTerms"
            name="confirmReviewedTerms"
            (change)="onChangeEventTerms($event)"
            formControlName="confirmReviewedTerms"
          >
          I agree to the terms and conditions of the
            <a
              href="{{programRulesLink}}"
              target="_blank" rel="noopener"
              >{{programRulesLinkText}}</a
            >, including, but not limited to the release of CRMP, 
            CEA, and Cal OES, of and from any and all manner of 
            suits, liabilities, losses, damages, and claims, 
            related to or arising out of or in any way related 
            to my participation in the Program, including but 
            not limited to, my receipt of a grant from the Program.
          </mat-checkbox>
          <span>
      
          </span>
        </form>
        <button
          mat-raised-button
          style="margin-top: 18px;"
          color="accent"
          [disabled]="disableSave"
          (click)="onClickYes()"
        >
          YES
        </button>
      </div>
    </mat-card>
  </section>
</div>